import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import "../Component/Home/Home.css"
import Side from "../Component/sidecontainer/side";
import homePage from "../media/accpage3.jpg";
import amis from "../media/amis.svg";
import conversation_apropo from "../media/conversation_apropo.svg";
import fils from "../media/fils.svg";
import audioCallFont from "../media/audioCallFont.jpeg";
import videocall from "../media/videoFont.png"
import cover from "../media/font.jpeg";
import logonobg from "../media/logonobg.png";
import fondfont from "../media/font.jpeg";
import messagerie2 from "../media/messagerie2.jpg";
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import Translate from '../Component/Translate/Translate';
import SideBarAdmin from '../Component/Admin/SideBarAdmin';
import Footer from '../Helper/Footer';
import TutorialWidget from '../Component/Tutorial/TutorialWidget';
import AuthService, { stillActive } from '../HTTP/auth.service.js';

const locationInfo = {
    "/": {
        bgImage: homePage,
        sideBar: "empty"
    },
    "search": {
        bgImage: fils,
        sideBar: "thematics"
    },
    "friends-msg": {
        bgImage: cover,
        sideBar: "empty"
    },
    "profile": {
        bgImage: cover,
        sideBar: "empty"
    },
    "friends": {
        bgImage: amis,
        sideBar: "empty"
    },
    "favourites": {
        bgImage: amis,
        sideBar: "empty"
    },
    "conv": {
        bgImage: conversation_apropo,
        sideBar: "friends_requests"
    },
    "feed": {
        bgImage: cover,
        sideBar: "empty"
    },
    "audiocall": {
        bgImage: audioCallFont,
        sideBar: "empty"
    },    
    "videocall": {
        bgImage: videocall,
        sideBar: "empty"
    },    
    "reviews": {
        bgImage: cover,
        sideBar: "empty"
    },    
    "myarticles": {
        bgImage: cover,
        sideBar: "empty"
    },
    "zemus-ia": {
        bgImage: messagerie2,
        sideBar: "thematics"
    },
    "igo": {
        bgImage: cover,
        sideBar: "empty"
    },
    "regionspresentation": {
        bgImage: cover,
        sideBar: "empty"
    },
    "conditions": {
        bgImage: cover,
        sideBar: "empty"
    },
    "legales": {
        bgImage: cover,
        sideBar: "empty"
    },
    "politique": {
        bgImage: cover,
        sideBar: "empty"
    },
} 

const resolveLocationKey = () => {
    const pathname = window.location.pathname

    if (pathname === "/") {
        return "/"
    }

    if (pathname === "/search" || pathname === "/zemus-ia") {
        return pathname.slice(1)
    }

    if (pathname.includes("/what-this-country-talk-about") || pathname.includes("/the-country-speaks-of") || pathname.includes("/which-countries-speak-about")) {
        return "search"
    }

    const currentPath = pathname.split("/")[1]

    if (locationInfo[currentPath]) {
        return currentPath
    }

    return "/"
}

const Sidebar = () => {
    const [isOpen, setIsOpen] = useState(window.innerWidth >= 768);
    const currentPath = resolveLocationKey()
    useEffect(() => {
        const handleResize = () => {
            setIsOpen(window.innerWidth >= 768);
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <div className="mainsidebar">
            {/* Bouton pour basculer l'état de la sidebar */}
            <button onClick={() => setIsOpen(!isOpen)} className="menuburger">
                {isOpen ? <XMarkIcon className="h-6 w-6"/> : <Bars3Icon className="h-6 w-6"/>}
            </button>

            {/* Contenu de la Sidebar */}
            <div
                className={`z-20 inset-y-0 left-0 overflow-hidden
                    ${isOpen ? 'w-64 translate-x-0' : 'w-0 -translate-x-full'}
                    transition-all duration-200 ease-in-out`}
                >
                <Side sideBarLowerSection={locationInfo[currentPath].sideBar} />
            </div>
        </div>
    );
};

const useStillActiveGuard = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        let cancelled = false;

        const checkCurrentUser = async () => {
            const token = localStorage.getItem('token');
            const rawUser = localStorage.getItem('user');

            if (!token) {
                return;
            }

            if (!rawUser) {
                AuthService.logout();
                navigate('/login', { replace: true });
                return;
            }

            let localUser = null;
            try {
                localUser = JSON.parse(rawUser);
            } catch (error) {
                AuthService.logout();
                navigate('/login', { replace: true });
                return;
            }

            if (!localUser?.id) {
                AuthService.logout();
                navigate('/login', { replace: true });
                return;
            }

            const isStillActive = await stillActive(localUser.id);

            if (cancelled) {
                return;
            }

            if (isStillActive === false) {
                AuthService.logout();
                navigate('/login', { replace: true });
            }
        };

        checkCurrentUser();

        return () => {
            cancelled = true;
        };
    }, [location.pathname, location.search, navigate]);
};

export default function GeneralContainerWrapper(Component) {

    const currentPath = resolveLocationKey()

    if (!localStorage.getItem("token")) {
        return (props) => {
            return (
                <div >  
                        <div className="public-banner flex w-full">
                            <div className="public-grey p-4">
                                <img src={logonobg} width="150" alt="Logo" />  
                            </div> 
                             <div className="public-blue p-2 w-full">
                                <a href="/login" className="text-white bg-transparent border border-white mr-2  rounded-xl">
                                    Je me connecte
                                </a>
                                <a href="login" className="bg-white rounded-xl">
                                    Je m'inscris
                                </a>
                            </div>
                        </div>        
                        <div className="public-container"
                         style = {{ backgroundImage: `url(${ fondfont })`,
                                    backgroundAttachment: 'fixed',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover'}}   
                         >
                            <Component/>
                        </div>  
                </div>
            )
         }
    }

    function ProtectedGeneralContainer(props) {
        useStillActiveGuard();

        return (
            <div
                className="homecontainer"
                style = {{ backgroundImage: `url(${ locationInfo[currentPath].bgImage })` }}   
            >
                <div className="sidprof">
                    <div className="flex">
                        <Sidebar/>
                                <div className="allcontainer">
                                    <div className="w-full flex justify-end items-center gap-2">
                                        <TutorialWidget />
                                        <Translate />
                                    </div>
                                    <Component/>
                                    <Footer/>
                                </div>
                    </div>
                </div>
            </div>
        )
    }

    return ProtectedGeneralContainer
}

export function AdminContainerWrapper(Component) {
    function ProtectedAdminContainer(props) {
        useStillActiveGuard();

        const localUser = JSON.parse(localStorage.getItem("user") || "null")
        if (!localUser || (!localUser.admin && localUser.admin_access < 1)) {
            window.location.href = '/'
        }
        return (
            <div className="homecontainer">
                <div className="sidprof">
                    <div className="flex">
                        <SideBarAdmin />
                        <div className="allcontainer">
                            <div className="w-full flex justify-start items-center gap-2 pl-2 pt-2">
                                <TutorialWidget />
                                <Translate />
                            </div>
                            <Component/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return ProtectedAdminContainer
}
